import React from "react";

import styles from "../../notification.module.css";

const NotificationEmptyState = () => {
  return (
    <div className={styles.empty_state_container}>
      <img src="/no-notifications.png" alt="No notifications" />
      <span>No new notification</span>
      <p>Any new notification will appear here</p>
    </div>
  );
};

export default NotificationEmptyState;
